import { FormattedMessage } from 'react-intl'
import { Content, ContentHeader } from 'components/v2/Content'
import Heading from 'components/v2/Heading'
import Card from '@10xLabs/react-web/components/Card'
import { NewPreferredSeatsAncillaryForm } from 'features/Ancillaries/components/NewPreferredSeatsAncillaryForm'
import { useMutation } from '@apollo/client'
import { CREATE_ANCILLARY } from 'features/Ancillaries/mutations-legacy'
import { ReactElement } from 'react'
import { useNavigate } from 'react-router'
import { mapPreferredSeatsAncillaryToForm, mapPreferredSeatsAncillaryToMutation } from 'resolvers/ancillaries'
import { INewPreferredSeatsAncillaryForm } from 'features/Ancillaries/components/NewPreferredSeatsAncillaryForm/types'
import styled from 'styled-components'
import { useLogin } from 'features/Login/hooks'
import { GTAncillaryType } from 'gql/types.generated'
import { getDefaultCompanyForForm } from 'features/Login/utils'

const Container = styled.div`
  max-width: 1000px;
  margin: 0 auto;
`

const NewPreferredSeatsAncillaryView = (): ReactElement => {
  const navigate = useNavigate()

  const [createAncillary, { loading, error }] = useMutation(CREATE_ANCILLARY, {
    onCompleted: () => {
      navigate('/ancillaries/preferred-seats')
    },
    onError: () => {
      /*Do nothing*/
    }
  })
  const handleSubmit = (values: INewPreferredSeatsAncillaryForm): void => {
    const input = mapPreferredSeatsAncillaryToMutation(values)
    createAncillary({
      variables: {
        input
      }
    })
  }
  const login = useLogin()
  const ancillaryInitialData = mapPreferredSeatsAncillaryToForm({
    type: '' as GTAncillaryType,
    isEnabled: true,
    salesChannels: [],
    salesChannelsV2: [],
    label: [],
    company: getDefaultCompanyForForm(login.accessToken),
    name: '',
    id: '',
    conditions: {
      salesChannels: []
    }
  })
  return (
    <Container>
      <Content>
        <ContentHeader>
          <Heading.H3>
            <FormattedMessage id="preferredSeatsAncillary.new.title" defaultMessage="Preferred seats" />
          </Heading.H3>
        </ContentHeader>
        <section>
          <Card.Container>
            <NewPreferredSeatsAncillaryForm
              onSubmit={handleSubmit}
              loading={loading}
              error={error}
              ancillary={ancillaryInitialData}
            />
          </Card.Container>
        </section>
      </Content>
    </Container>
  )
}

export default NewPreferredSeatsAncillaryView
